import { render } from "./FormNewsletter.vue?vue&type=template&id=156f04f4"
import script from "./FormNewsletter.vue?vue&type=script&lang=js"
export * from "./FormNewsletter.vue?vue&type=script&lang=js"

import "./FormNewsletter.vue?vue&type=style&index=0&id=156f04f4&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__